import React, { PureComponent } from "react";
import { connect } from "react-redux";
import Modal from "react-modal";

import { closeMailViewer } from "Actions";
import CloseViewer from "../CloseViewer";
import Content from "./Content";

const customStyles = {
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
    border: "none",
    overflow: "none",
    padding: 0,
    top: "3%",
    left: "15%",
    right: "15%",
    bottom: "3%",
    borderRadius: "5px",
    boxShadow: "0px 0px 10px rgba(41, 57, 77, 0.04)"
  }
};

class MailViewer extends PureComponent {
  handleAfterOpenModal() {}

  handleCloseModal() {
    this.props.closeMailViewer();
  }

  render() {
    const { viewer } = this.props;

    if (!viewer.isOpen) {
      return false;
    }
    return (
      <Modal
        isOpen={viewer.isOpen}
        onAfterOpen={this.handleAfterOpenModal}
        onRequestClose={this.handleCloseModal.bind(this)}
        shouldCloseOnOverlayClick={true}
        style={customStyles}
        contentLabel="Mail Viewer"
      >
        <div className="rmodal" id="newArticleViewer">
          <CloseViewer closeViewer={this.props.closeMailViewer} />
          <Content />
        </div>
      </Modal>
    );
  }
}

// Connected Component
const mapStateToProps = (state, ownProps) => ({
  viewer: state.mailViewer
});

const mapDispatchToProps = dispatch => ({
  closeMailViewer: () => dispatch(closeMailViewer())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MailViewer);



// WEBPACK FOOTER //
// ./src/components/Reveal/MailViewer/index.js